export const PBM = [
  "mouth", // mask
  "eye", // goggles
  "body", // vest
  "fall", // fall safety
  "feet", // boots
  "hand", // gloves
  "head", // hard-head
  "ears" // headphones
];

export const contactTypes = [
  "general",
  "reception",
  "planning",
  "sales",
  "purchasing",
  "other"
];

export const contactTitles = ["mr", "mrs", "miss", "sir", "dr"];
